import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Calendar, Clock, ArrowRight } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { blogPosts } from '../data/mockData';

const Blog = () => {
  const navigate = useNavigate();

  const handlePostClick = (postId) => {
    navigate(`/blog/${postId}`);
  };

  return (
    <section id="blog" className="py-24" style={{ backgroundColor: 'white' }}>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 
            className="text-4xl font-bold mb-4"
            style={{ color: '#3B3838' }}
          >
            Blog y Recursos
          </h2>
          <p 
            className="text-lg"
            style={{ color: '#6B7280' }}
          >
            Consejos, tendencias y conocimientos expertos sobre limpieza profesional 
            y mantenimiento de espacios.
          </p>
        </div>

        {/* Blog Posts Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {blogPosts.map((post) => (
            <Card 
              key={post.id}
              onClick={() => handlePostClick(post.id)}
              className="group hover:shadow-xl transition-all duration-300 cursor-pointer overflow-hidden"
            >
              {/* Featured Image */}
              <div className="h-48 relative overflow-hidden">
                {post.image ? (
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                ) : (
                  <div 
                    className="w-full h-full relative"
                    style={{ backgroundColor: '#E8F2FA' }}
                  >
                    <div className="absolute inset-0 flex items-center justify-center">
                      <div 
                        className="text-6xl font-bold opacity-10"
                        style={{ color: '#2E75B6' }}
                      >
                        MERX
                      </div>
                    </div>
                  </div>
                )}
                {/* Category Badge */}
                <div 
                  className="absolute top-4 left-4 px-3 py-1 rounded-full text-xs font-semibold"
                  style={{ 
                    backgroundColor: '#FFC000',
                    color: '#3B3838'
                  }}
                >
                  {post.category}
                </div>
              </div>

              <CardHeader>
                <div className="flex items-center gap-4 mb-3 text-sm" style={{ color: '#6B7280' }}>
                  <div className="flex items-center gap-1">
                    <Calendar size={16} />
                    <span>{post.date}</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <Clock size={16} />
                    <span>{post.readTime}</span>
                  </div>
                </div>
                <CardTitle 
                  className="text-xl font-bold group-hover:text-[#2E75B6] transition-colors"
                  style={{ color: '#3B3838' }}
                >
                  {post.title}
                </CardTitle>
              </CardHeader>
              
              <CardContent>
                <CardDescription 
                  className="text-base mb-4"
                  style={{ color: '#6B7280' }}
                >
                  {post.excerpt}
                </CardDescription>
                
                <button 
                  className="flex items-center gap-2 font-semibold text-sm group-hover:gap-3 transition-all"
                  style={{ color: '#2E75B6' }}
                >
                  Leer más
                  <ArrowRight size={16} />
                </button>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* View All Button */}
        <div className="text-center mt-12">
          <button
            onClick={() => navigate('/blog/1')}
            className="px-8 py-3 rounded-lg font-semibold transition-all duration-300 hover:scale-105 border-2"
            style={{ 
              borderColor: '#2E75B6',
              color: '#2E75B6',
              backgroundColor: 'white'
            }}
          >
            Ver Todos los Artículos
          </button>
        </div>
      </div>
    </section>
  );
};

export default Blog;
